import { render } from "./TestReports.vue?vue&type=template&id=3b2b1abb"
import script from "./TestReports.vue?vue&type=script&lang=js"
export * from "./TestReports.vue?vue&type=script&lang=js"

import "./TestReports.vue?vue&type=style&index=0&id=3b2b1abb&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/TestReports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b2b1abb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b2b1abb', __exports__)) {
    console.log('reload')
    api.reload('3b2b1abb', __exports__)
  }
  
  module.hot.accept("./TestReports.vue?vue&type=template&id=3b2b1abb", () => {
    console.log('re-render')
    api.rerender('3b2b1abb', render)
  })

}


export default __exports__